{
  "commerce": {
    "aiChatView": {
      "errorPausedDetail": "AI is included with a subscription — open Settings → Billing to subscribe."
    },
    "billingPage": {
      "title": "Billing"
    },
    "paywallGate": {
      "errorOpenBilling": "Couldn't open billing. Try again.",
      "lapsedDescription": "Resubscribe to keep managing your property: 30 € per unit per month, with AI included.",
      "pastDue": "Payment failed. Update your payment method to keep access.",
      "startTrial": "Start {days}-day free trial",
      "subscribe": "Subscribe",
      "subscribeDescription": "You've already used your free trial. Subscribe to keep managing your property: 30 € per unit per month, with AI included.",
      "subscribeTitle": "Subscribe to Vidimo",
      "trialAddPaymentMethod": "Add a payment method to keep access.",
      "trialDescription": "Try Vidimo free for {days} days, no card required. Then 30 € per unit per month, with AI included.",
      "trialTitle": "Start your free trial"
    },
    "propertySettingsView": {
      "billingDescription": "Subscription, AI usage and payment method",
      "billingTitle": "Billing"
    },
    "subscriptionGate": {
      "aiIncluded": "AI features are included with your plan.",
      "aiTitle": "AI",
      "errorGeneric": "Something went wrong",
      "errorLoad": "Failed to load billing",
      "manageSubscription": "Manage subscription",
      "status": {
        "active": "Active",
        "past_due": "Payment overdue",
        "trialing": "Free trial"
      },
      "subscribe": "Subscribe",
      "subscribePrice": "30 € per unit per month, billed to the number of units in this property. AI features are included.",
      "subscribeTitle": "Subscribe",
      "subscribedPrice": "30 € per unit per month. Adding or removing a unit updates your bill automatically.",
      "subscriptionTitle": "Subscription"
    }
  }
}
